import { fansupportPublic } from "../index";

export const getAdsMain = async ({ countryId, languageId, platformType }) => {
    return fansupportPublic.get('/media-content/main-media', {params: {
        countryId,
        languageId,
        platformType
    }})
}